module.exports = __webpack_public_path__ + "static/Underdown5-b6ce38bcd8cba10e99a022ae44107e9b.png";